import Editor from "./lib";

if (window) {
  (window as any).Editor = Editor;
}

export default Editor;
